import api from "@/apis/customercontacts/CustomerContactsAPI";
import Crud from "@/stores/crud-base";
import httpClient from "@/apis/base/axios-httpclient";
var crud = new Crud("customercontacts", api);

const state = {
  ...crud.state,
  /**
   * Cấu hình của module
   */
  _config: {
    field: {
      key: "code",
    },
  },

  data: [],
};

const getters = {
  ...crud.getters,
};

const actions = {
  ...crud.actions,
};

const mutations = {
  ...crud.mutations,
};

export default {
  debug: import.meta.env.PROD,
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
